import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIHoverActionController} from './UIHoverActionController'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorShip} from '@colonist/game-mechanic-validators'
import {MechanicPirateState, MechanicShipState, TileEdgeDirection} from '@colonist/game-states'

export class UIShipHoverActionController extends UIHoverActionController {
    private readonly validatorShip: MechanicValidatorShip

    constructor(uiGameManager: UIGameManager, shipState: MechanicShipState, mechanicPirateState: MechanicPirateState | undefined) {
        super(uiGameManager)
        this.resources = getCardsForPiece(PieceTypes.Ship)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildShipSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileEdgeHoverAction(this)
        this.validatorShip = new MechanicValidatorShip(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, shipState, mechanicPirateState)
    }

    getBankActionAmount(index: number): number {
        const myPlayer = this.validatorShip.getShipPlayerState(this.uiGameManager.gameController.myColor)
        return myPlayer.bankShipAmount
    }

    protected updateState() {
        const player = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor)
        const useResources = true
        const canPlaceShip = this.validatorShip.canPlayerPlaceShip(player.color, useResources)
        this.updateHoverLocations(canPlaceShip.validHoverLocations, canPlaceShip.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getShipForPlayer(this.uiGameManager.gameController.myColor, TileEdgeDirection.NorthWest)
    }
}
